//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios from 'axios'
import type {
  AxiosError,
  AxiosInstance,
  AxiosRequestConfig,
  AxiosResponse,
  CancelToken,
} from 'axios'
export default class AuthorizedApiBase {
  /**
   * Used to transform the {@link AxiosRequestConfig}. Enables enrichment of the
   * request header to include, for example, the bearer token.
   * @param options
   */
  protected transformOptions = (options: AxiosRequestConfig): Promise<AxiosRequestConfig> => {
    const newOptions: AxiosRequestConfig = options

    // needed to prevent double json parsing (axios vs nswag)
    options.transformResponse = undefined

    newOptions.headers = {
      ...options.headers,
    }

    newOptions.withCredentials = true

    return Promise.resolve(newOptions)
  }
}

export interface IApiKeysApiClient {
    /**
     * @return Created
     */
    apiKeysPOST(body: CreateApiKeyRequest,  cancelToken?: CancelToken): Promise<CreateApiKeyResponse>;
    /**
     * @return OK
     */
    apiKeysAll( cancelToken?: CancelToken): Promise<ApiKeySummary[]>;
    /**
     * @return OK
     */
    rotate(id: string,  cancelToken?: CancelToken): Promise<CreateApiKeyResponse>;
    /**
     * @return No Content
     */
    apiKeysDELETE(id: string,  cancelToken?: CancelToken): Promise<void>;
}

export class ApiKeysApiClient extends AuthorizedApiBase implements IApiKeysApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://api.team-quantum.cloud/";

    }

    /**
     * @return Created
     */
    apiKeysPOST(body: CreateApiKeyRequest, cancelToken?: CancelToken): Promise<CreateApiKeyResponse> {
        let url_ = this.baseUrl + "/api-keys";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiKeysPOST(_response);
        });
    }

    protected processApiKeysPOST(response: AxiosResponse): Promise<CreateApiKeyResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = CreateApiKeyResponse.fromJS(resultData201);
            return Promise.resolve<CreateApiKeyResponse>(result201);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateApiKeyResponse>(null as any);
    }

    /**
     * @return OK
     */
    apiKeysAll( cancelToken?: CancelToken): Promise<ApiKeySummary[]> {
        let url_ = this.baseUrl + "/api-keys";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiKeysAll(_response);
        });
    }

    protected processApiKeysAll(response: AxiosResponse): Promise<ApiKeySummary[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApiKeySummary.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<ApiKeySummary[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiKeySummary[]>(null as any);
    }

    /**
     * @return OK
     */
    rotate(id: string, cancelToken?: CancelToken): Promise<CreateApiKeyResponse> {
        let url_ = this.baseUrl + "/api-keys/{id}/rotate";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRotate(_response);
        });
    }

    protected processRotate(response: AxiosResponse): Promise<CreateApiKeyResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateApiKeyResponse.fromJS(resultData200);
            return Promise.resolve<CreateApiKeyResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateApiKeyResponse>(null as any);
    }

    /**
     * @return No Content
     */
    apiKeysDELETE(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api-keys/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApiKeysDELETE(_response);
        });
    }

    protected processApiKeysDELETE(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IAuthenticationApiClient {
    /**
     * @return OK
     */
    scopes( cancelToken?: CancelToken): Promise<ApiKeyScopesResponse>;
}

export class AuthenticationApiClient extends AuthorizedApiBase implements IAuthenticationApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://api.team-quantum.cloud/";

    }

    /**
     * @return OK
     */
    scopes( cancelToken?: CancelToken): Promise<ApiKeyScopesResponse> {
        let url_ = this.baseUrl + "/auth/scopes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processScopes(_response);
        });
    }

    protected processScopes(response: AxiosResponse): Promise<ApiKeyScopesResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiKeyScopesResponse.fromJS(resultData200);
            return Promise.resolve<ApiKeyScopesResponse>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiKeyScopesResponse>(null as any);
    }
}

export interface IInfoApiClient {
    /**
     * @return OK
     */
    info( cancelToken?: CancelToken): Promise<ApiInfoResponse>;
    /**
     * @return OK
     */
    health( cancelToken?: CancelToken): Promise<string>;
}

export class InfoApiClient extends AuthorizedApiBase implements IInfoApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://api.team-quantum.cloud/";

    }

    /**
     * @return OK
     */
    info( cancelToken?: CancelToken): Promise<ApiInfoResponse> {
        let url_ = this.baseUrl + "/info";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processInfo(_response);
        });
    }

    protected processInfo(response: AxiosResponse): Promise<ApiInfoResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiInfoResponse.fromJS(resultData200);
            return Promise.resolve<ApiInfoResponse>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiInfoResponse>(null as any);
    }

    /**
     * @return OK
     */
    health( cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/info/health";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processHealth(_response);
        });
    }

    protected processHealth(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }
}

export interface IJokesApiClient {
    /**
     * @param category (optional) 
     * @param lang (optional) 
     * @param type (optional) 
     * @param blacklistFlags (optional) 
     * @return OK
     */
    random(category?: JokeCategory | undefined, lang?: string | undefined, type?: JokeType | undefined, blacklistFlags?: string | undefined,  cancelToken?: CancelToken): Promise<JokeResponse>;
    /**
     * @param category (optional) 
     * @param lang (optional) 
     * @return OK
     */
    jokesAll(category?: JokeCategory | undefined, lang?: string | undefined,  cancelToken?: CancelToken): Promise<JokeResponse[]>;
    /**
     * @return Created
     */
    jokesPOST(body: CreateJokeRequest,  cancelToken?: CancelToken): Promise<JokeResponse>;
    /**
     * @return No Content
     */
    jokesDELETE(id: string,  cancelToken?: CancelToken): Promise<void>;
}

export class JokesApiClient extends AuthorizedApiBase implements IJokesApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://api.team-quantum.cloud/";

    }

    /**
     * @param category (optional) 
     * @param lang (optional) 
     * @param type (optional) 
     * @param blacklistFlags (optional) 
     * @return OK
     */
    random(category?: JokeCategory | undefined, lang?: string | undefined, type?: JokeType | undefined, blacklistFlags?: string | undefined, cancelToken?: CancelToken): Promise<JokeResponse> {
        let url_ = this.baseUrl + "/jokes/random?";
        if (category === null)
            throw new globalThis.Error("The parameter 'category' cannot be null.");
        else if (category !== undefined)
            url_ += "category=" + encodeURIComponent("" + category) + "&";
        if (lang === null)
            throw new globalThis.Error("The parameter 'lang' cannot be null.");
        else if (lang !== undefined)
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        if (type === null)
            throw new globalThis.Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        if (blacklistFlags === null)
            throw new globalThis.Error("The parameter 'blacklistFlags' cannot be null.");
        else if (blacklistFlags !== undefined)
            url_ += "blacklistFlags=" + encodeURIComponent("" + blacklistFlags) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRandom(_response);
        });
    }

    protected processRandom(response: AxiosResponse): Promise<JokeResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JokeResponse.fromJS(resultData200);
            return Promise.resolve<JokeResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<JokeResponse>(null as any);
    }

    /**
     * @param category (optional) 
     * @param lang (optional) 
     * @return OK
     */
    jokesAll(category?: JokeCategory | undefined, lang?: string | undefined, cancelToken?: CancelToken): Promise<JokeResponse[]> {
        let url_ = this.baseUrl + "/jokes?";
        if (category === null)
            throw new globalThis.Error("The parameter 'category' cannot be null.");
        else if (category !== undefined)
            url_ += "category=" + encodeURIComponent("" + category) + "&";
        if (lang === null)
            throw new globalThis.Error("The parameter 'lang' cannot be null.");
        else if (lang !== undefined)
            url_ += "lang=" + encodeURIComponent("" + lang) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processJokesAll(_response);
        });
    }

    protected processJokesAll(response: AxiosResponse): Promise<JokeResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(JokeResponse.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<JokeResponse[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<JokeResponse[]>(null as any);
    }

    /**
     * @return Created
     */
    jokesPOST(body: CreateJokeRequest, cancelToken?: CancelToken): Promise<JokeResponse> {
        let url_ = this.baseUrl + "/jokes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processJokesPOST(_response);
        });
    }

    protected processJokesPOST(response: AxiosResponse): Promise<JokeResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = JokeResponse.fromJS(resultData201);
            return Promise.resolve<JokeResponse>(result201);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<JokeResponse>(null as any);
    }

    /**
     * @return No Content
     */
    jokesDELETE(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/jokes/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processJokesDELETE(_response);
        });
    }

    protected processJokesDELETE(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface ILicensesApiClient {
    /**
     * @return OK
     */
    licensesGET( cancelToken?: CancelToken): Promise<void>;
    /**
     * @return OK
     */
    licensesPOST(body: GenerateLicenseRequest,  cancelToken?: CancelToken): Promise<void>;
    /**
     * @param product (optional) 
     * @param licenseKey (optional) 
     * @return OK
     */
    verify(product?: string | undefined, licenseKey?: string | undefined,  cancelToken?: CancelToken): Promise<void>;
}

export class LicensesApiClient extends AuthorizedApiBase implements ILicensesApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://api.team-quantum.cloud/";

    }

    /**
     * @return OK
     */
    licensesGET( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/licenses";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLicensesGET(_response);
        });
    }

    protected processLicensesGET(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    licensesPOST(body: GenerateLicenseRequest, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/licenses";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLicensesPOST(_response);
        });
    }

    protected processLicensesPOST(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param product (optional) 
     * @param licenseKey (optional) 
     * @return OK
     */
    verify(product?: string | undefined, licenseKey?: string | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/licenses/verify?";
        if (product === null)
            throw new globalThis.Error("The parameter 'product' cannot be null.");
        else if (product !== undefined)
            url_ += "product=" + encodeURIComponent("" + product) + "&";
        if (licenseKey === null)
            throw new globalThis.Error("The parameter 'licenseKey' cannot be null.");
        else if (licenseKey !== undefined)
            url_ += "licenseKey=" + encodeURIComponent("" + licenseKey) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processVerify(_response);
        });
    }

    protected processVerify(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IMediaApiClient {
    /**
     * @param term (optional) 
     * @param includeData (optional) 
     * @return OK
     */
    random2(term?: string | undefined, includeData?: boolean | undefined,  cancelToken?: CancelToken): Promise<MediaResponse>;
    /**
     * @return OK
     */
    mediaGET(id: string,  cancelToken?: CancelToken): Promise<void>;
    /**
     * @return No Content
     */
    mediaDELETE(id: string,  cancelToken?: CancelToken): Promise<void>;
    /**
     * @return Created
     */
    mediaPOST(body: Body,  cancelToken?: CancelToken): Promise<MediaResponse>;
}

export class MediaApiClient extends AuthorizedApiBase implements IMediaApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://api.team-quantum.cloud/";

    }

    /**
     * @param term (optional) 
     * @param includeData (optional) 
     * @return OK
     */
    random2(term?: string | undefined, includeData?: boolean | undefined, cancelToken?: CancelToken): Promise<MediaResponse> {
        let url_ = this.baseUrl + "/media/random?";
        if (term === null)
            throw new globalThis.Error("The parameter 'term' cannot be null.");
        else if (term !== undefined)
            url_ += "term=" + encodeURIComponent("" + term) + "&";
        if (includeData === null)
            throw new globalThis.Error("The parameter 'includeData' cannot be null.");
        else if (includeData !== undefined)
            url_ += "includeData=" + encodeURIComponent("" + includeData) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRandom2(_response);
        });
    }

    protected processRandom2(response: AxiosResponse): Promise<MediaResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MediaResponse.fromJS(resultData200);
            return Promise.resolve<MediaResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MediaResponse>(null as any);
    }

    /**
     * @return OK
     */
    mediaGET(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/media/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMediaGET(_response);
        });
    }

    protected processMediaGET(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return No Content
     */
    mediaDELETE(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/media/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMediaDELETE(_response);
        });
    }

    protected processMediaDELETE(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Created
     */
    mediaPOST(body: Body, cancelToken?: CancelToken): Promise<MediaResponse> {
        let url_ = this.baseUrl + "/media";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = Object.keys(body as any).map((key) => {
            return encodeURIComponent(key) + '=' + encodeURIComponent((body as any)[key]);
        }).join('&')

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMediaPOST(_response);
        });
    }

    protected processMediaPOST(response: AxiosResponse): Promise<MediaResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = MediaResponse.fromJS(resultData201);
            return Promise.resolve<MediaResponse>(result201);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MediaResponse>(null as any);
    }
}

export interface IQuestionsApiClient {
    /**
     * @param rating (optional) 
     * @param category (optional) 
     * @return OK
     */
    random3(rating?: ContentRating | undefined, category?: string | undefined,  cancelToken?: CancelToken): Promise<QuestionResponse>;
    /**
     * @param rating (optional) 
     * @return OK
     */
    questionsAll(rating?: ContentRating | undefined,  cancelToken?: CancelToken): Promise<QuestionResponse[]>;
    /**
     * @return Created
     */
    questionsPOST(body: CreateQuestionRequest,  cancelToken?: CancelToken): Promise<QuestionResponse>;
    /**
     * @return No Content
     */
    questionsDELETE(id: string,  cancelToken?: CancelToken): Promise<void>;
}

export class QuestionsApiClient extends AuthorizedApiBase implements IQuestionsApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://api.team-quantum.cloud/";

    }

    /**
     * @param rating (optional) 
     * @param category (optional) 
     * @return OK
     */
    random3(rating?: ContentRating | undefined, category?: string | undefined, cancelToken?: CancelToken): Promise<QuestionResponse> {
        let url_ = this.baseUrl + "/questions/random?";
        if (rating === null)
            throw new globalThis.Error("The parameter 'rating' cannot be null.");
        else if (rating !== undefined)
            url_ += "rating=" + encodeURIComponent("" + rating) + "&";
        if (category === null)
            throw new globalThis.Error("The parameter 'category' cannot be null.");
        else if (category !== undefined)
            url_ += "category=" + encodeURIComponent("" + category) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRandom3(_response);
        });
    }

    protected processRandom3(response: AxiosResponse): Promise<QuestionResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QuestionResponse.fromJS(resultData200);
            return Promise.resolve<QuestionResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QuestionResponse>(null as any);
    }

    /**
     * @param rating (optional) 
     * @return OK
     */
    questionsAll(rating?: ContentRating | undefined, cancelToken?: CancelToken): Promise<QuestionResponse[]> {
        let url_ = this.baseUrl + "/questions?";
        if (rating === null)
            throw new globalThis.Error("The parameter 'rating' cannot be null.");
        else if (rating !== undefined)
            url_ += "rating=" + encodeURIComponent("" + rating) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQuestionsAll(_response);
        });
    }

    protected processQuestionsAll(response: AxiosResponse): Promise<QuestionResponse[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(QuestionResponse.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return Promise.resolve<QuestionResponse[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QuestionResponse[]>(null as any);
    }

    /**
     * @return Created
     */
    questionsPOST(body: CreateQuestionRequest, cancelToken?: CancelToken): Promise<QuestionResponse> {
        let url_ = this.baseUrl + "/questions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQuestionsPOST(_response);
        });
    }

    protected processQuestionsPOST(response: AxiosResponse): Promise<QuestionResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = QuestionResponse.fromJS(resultData201);
            return Promise.resolve<QuestionResponse>(result201);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QuestionResponse>(null as any);
    }

    /**
     * @return No Content
     */
    questionsDELETE(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/questions/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQuestionsDELETE(_response);
        });
    }

    protected processQuestionsDELETE(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IMiyuImagesApiClient {
    /**
     * @return Created
     */
    imagesPOST(body: Body2,  cancelToken?: CancelToken): Promise<MediaResponse>;
    /**
     * @return No Content
     */
    imagesDELETE(id: string,  cancelToken?: CancelToken): Promise<void>;
}

export class MiyuImagesApiClient extends AuthorizedApiBase implements IMiyuImagesApiClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://api.team-quantum.cloud/";

    }

    /**
     * @return Created
     */
    imagesPOST(body: Body2, cancelToken?: CancelToken): Promise<MediaResponse> {
        let url_ = this.baseUrl + "/miyu/images";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = Object.keys(body as any).map((key) => {
            return encodeURIComponent(key) + '=' + encodeURIComponent((body as any)[key]);
        }).join('&')

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImagesPOST(_response);
        });
    }

    protected processImagesPOST(response: AxiosResponse): Promise<MediaResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201: any = null;
            let resultData201  = _responseText;
            result201 = MediaResponse.fromJS(resultData201);
            return Promise.resolve<MediaResponse>(result201);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MediaResponse>(null as any);
    }

    /**
     * @return No Content
     */
    imagesDELETE(id: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/miyu/images/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImagesDELETE(_response);
        });
    }

    protected processImagesDELETE(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class ApiInfoResponse implements IApiInfoResponse {
    product!: string;
    version!: string;
    environment!: string;
    timeStamp!: string;
    company!: string;

    [key: string]: any;

    constructor(data?: IApiInfoResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.product = _data["product"];
            this.version = _data["version"];
            this.environment = _data["environment"];
            this.timeStamp = _data["timeStamp"];
            this.company = _data["company"];
        }
    }

    static fromJS(data: any): ApiInfoResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ApiInfoResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["product"] = this.product;
        data["version"] = this.version;
        data["environment"] = this.environment;
        data["timeStamp"] = this.timeStamp;
        data["company"] = this.company;
        return data;
    }
}

export interface IApiInfoResponse {
    product: string;
    version: string;
    environment: string;
    timeStamp: string;
    company: string;

    [key: string]: any;
}

export class ApiKeyScopesResponse implements IApiKeyScopesResponse {
    clientName!: string;
    scopes!: string[];
    isAdmin!: boolean;

    [key: string]: any;

    constructor(data?: IApiKeyScopesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.scopes = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.clientName = _data["clientName"];
            if (Array.isArray(_data["scopes"])) {
                this.scopes = [] as any;
                for (let item of _data["scopes"])
                    this.scopes!.push(item);
            }
            this.isAdmin = _data["isAdmin"];
        }
    }

    static fromJS(data: any): ApiKeyScopesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ApiKeyScopesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["clientName"] = this.clientName;
        if (Array.isArray(this.scopes)) {
            data["scopes"] = [];
            for (let item of this.scopes)
                data["scopes"].push(item);
        }
        data["isAdmin"] = this.isAdmin;
        return data;
    }
}

export interface IApiKeyScopesResponse {
    clientName: string;
    scopes: string[];
    isAdmin: boolean;

    [key: string]: any;
}

export class ApiKeySummary implements IApiKeySummary {
    id!: string;
    name!: string;
    prefix!: string;
    clientName!: string;
    scopes!: string[];
    isActive!: boolean;
    expiresAt!: Date | undefined;
    revokedAt!: Date | undefined;
    lastUsedAt!: Date | undefined;
    createdAt!: Date;

    [key: string]: any;

    constructor(data?: IApiKeySummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.scopes = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.name = _data["name"];
            this.prefix = _data["prefix"];
            this.clientName = _data["clientName"];
            if (Array.isArray(_data["scopes"])) {
                this.scopes = [] as any;
                for (let item of _data["scopes"])
                    this.scopes!.push(item);
            }
            this.isActive = _data["isActive"];
            this.expiresAt = _data["expiresAt"] ? new Date(_data["expiresAt"].toString()) : undefined as any;
            this.revokedAt = _data["revokedAt"] ? new Date(_data["revokedAt"].toString()) : undefined as any;
            this.lastUsedAt = _data["lastUsedAt"] ? new Date(_data["lastUsedAt"].toString()) : undefined as any;
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): ApiKeySummary {
        data = typeof data === 'object' ? data : {};
        let result = new ApiKeySummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["name"] = this.name;
        data["prefix"] = this.prefix;
        data["clientName"] = this.clientName;
        if (Array.isArray(this.scopes)) {
            data["scopes"] = [];
            for (let item of this.scopes)
                data["scopes"].push(item);
        }
        data["isActive"] = this.isActive;
        data["expiresAt"] = this.expiresAt ? this.expiresAt.toISOString() : undefined as any;
        data["revokedAt"] = this.revokedAt ? this.revokedAt.toISOString() : undefined as any;
        data["lastUsedAt"] = this.lastUsedAt ? this.lastUsedAt.toISOString() : undefined as any;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        return data;
    }
}

export interface IApiKeySummary {
    id: string;
    name: string;
    prefix: string;
    clientName: string;
    scopes: string[];
    isActive: boolean;
    expiresAt: Date | undefined;
    revokedAt: Date | undefined;
    lastUsedAt: Date | undefined;
    createdAt: Date;

    [key: string]: any;
}

/** Custom enum description */
export enum ContentRating {
    SafeForWork = "SafeForWork",
    NotSafeForWork = "NotSafeForWork",
}

export class CreateApiKeyRequest implements ICreateApiKeyRequest {
    name!: string;
    clientName!: string;
    scopes!: string[];
    isLive!: boolean;
    expiresAt!: Date | undefined;

    [key: string]: any;

    constructor(data?: ICreateApiKeyRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.scopes = [];
            this.isLive = true;
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.name = _data["name"];
            this.clientName = _data["clientName"];
            if (Array.isArray(_data["scopes"])) {
                this.scopes = [] as any;
                for (let item of _data["scopes"])
                    this.scopes!.push(item);
            }
            this.isLive = _data["isLive"] !== undefined ? _data["isLive"] : true;
            this.expiresAt = _data["expiresAt"] ? new Date(_data["expiresAt"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): CreateApiKeyRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateApiKeyRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["name"] = this.name;
        data["clientName"] = this.clientName;
        if (Array.isArray(this.scopes)) {
            data["scopes"] = [];
            for (let item of this.scopes)
                data["scopes"].push(item);
        }
        data["isLive"] = this.isLive;
        data["expiresAt"] = this.expiresAt ? this.expiresAt.toISOString() : undefined as any;
        return data;
    }
}

export interface ICreateApiKeyRequest {
    name: string;
    clientName: string;
    scopes: string[];
    isLive: boolean;
    expiresAt: Date | undefined;

    [key: string]: any;
}

export class CreateApiKeyResponse implements ICreateApiKeyResponse {
    id!: string;
    key!: string;
    prefix!: string;
    name!: string;
    clientName!: string;
    scopes!: string[];
    expiresAt!: Date | undefined;
    createdAt!: Date;

    [key: string]: any;

    constructor(data?: ICreateApiKeyResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.scopes = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.key = _data["key"];
            this.prefix = _data["prefix"];
            this.name = _data["name"];
            this.clientName = _data["clientName"];
            if (Array.isArray(_data["scopes"])) {
                this.scopes = [] as any;
                for (let item of _data["scopes"])
                    this.scopes!.push(item);
            }
            this.expiresAt = _data["expiresAt"] ? new Date(_data["expiresAt"].toString()) : undefined as any;
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): CreateApiKeyResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateApiKeyResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["key"] = this.key;
        data["prefix"] = this.prefix;
        data["name"] = this.name;
        data["clientName"] = this.clientName;
        if (Array.isArray(this.scopes)) {
            data["scopes"] = [];
            for (let item of this.scopes)
                data["scopes"].push(item);
        }
        data["expiresAt"] = this.expiresAt ? this.expiresAt.toISOString() : undefined as any;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined as any;
        return data;
    }
}

export interface ICreateApiKeyResponse {
    id: string;
    key: string;
    prefix: string;
    name: string;
    clientName: string;
    scopes: string[];
    expiresAt: Date | undefined;
    createdAt: Date;

    [key: string]: any;
}

export class CreateJokeRequest implements ICreateJokeRequest {
    category!: JokeCategory;
    language!: string;
    type!: JokeType;
    joke!: string;
    punchline!: string | undefined;
    flags!: string;

    [key: string]: any;

    constructor(data?: ICreateJokeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.category = _data["category"];
            this.language = _data["language"];
            this.type = _data["type"];
            this.joke = _data["joke"];
            this.punchline = _data["punchline"];
            this.flags = _data["flags"];
        }
    }

    static fromJS(data: any): CreateJokeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateJokeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["category"] = this.category;
        data["language"] = this.language;
        data["type"] = this.type;
        data["joke"] = this.joke;
        data["punchline"] = this.punchline;
        data["flags"] = this.flags;
        return data;
    }
}

export interface ICreateJokeRequest {
    category: JokeCategory;
    language: string;
    type: JokeType;
    joke: string;
    punchline: string | undefined;
    flags: string;

    [key: string]: any;
}

export class CreateQuestionRequest implements ICreateQuestionRequest {
    text!: string;
    rating!: ContentRating;
    category!: string | undefined;

    [key: string]: any;

    constructor(data?: ICreateQuestionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.text = _data["text"];
            this.rating = _data["rating"];
            this.category = _data["category"];
        }
    }

    static fromJS(data: any): CreateQuestionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateQuestionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["text"] = this.text;
        data["rating"] = this.rating;
        data["category"] = this.category;
        return data;
    }
}

export interface ICreateQuestionRequest {
    text: string;
    rating: ContentRating;
    category: string | undefined;

    [key: string]: any;
}

export class GenerateLicenseRequest implements IGenerateLicenseRequest {
    product!: string;
    remoteIp!: string | undefined;
    hasExpiration!: boolean;
    expirationDate!: Date | undefined;

    [key: string]: any;

    constructor(data?: IGenerateLicenseRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.product = _data["product"];
            this.remoteIp = _data["remoteIp"];
            this.hasExpiration = _data["hasExpiration"];
            this.expirationDate = _data["expirationDate"] ? new Date(_data["expirationDate"].toString()) : undefined as any;
        }
    }

    static fromJS(data: any): GenerateLicenseRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GenerateLicenseRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["product"] = this.product;
        data["remoteIp"] = this.remoteIp;
        data["hasExpiration"] = this.hasExpiration;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : undefined as any;
        return data;
    }
}

export interface IGenerateLicenseRequest {
    product: string;
    remoteIp: string | undefined;
    hasExpiration: boolean;
    expirationDate: Date | undefined;

    [key: string]: any;
}

/** Custom enum description */
export enum ImageCategory {
    Undefined = "Undefined",
    Action = "Action",
    Emote = "Emote",
}

/** Custom enum description */
export enum JokeCategory {
    Undefined = "Undefined",
    Misc = "Misc",
    Programming = "Programming",
    Dark = "Dark",
    Pun = "Pun",
    Spooky = "Spooky",
    Christmas = "Christmas",
}

export class JokeFlagsResponse implements IJokeFlagsResponse {
    nsfw!: boolean;
    religious!: boolean;
    political!: boolean;
    racist!: boolean;
    sexist!: boolean;
    explicit!: boolean;

    [key: string]: any;

    constructor(data?: IJokeFlagsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.nsfw = _data["nsfw"];
            this.religious = _data["religious"];
            this.political = _data["political"];
            this.racist = _data["racist"];
            this.sexist = _data["sexist"];
            this.explicit = _data["explicit"];
        }
    }

    static fromJS(data: any): JokeFlagsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new JokeFlagsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["nsfw"] = this.nsfw;
        data["religious"] = this.religious;
        data["political"] = this.political;
        data["racist"] = this.racist;
        data["sexist"] = this.sexist;
        data["explicit"] = this.explicit;
        return data;
    }
}

export interface IJokeFlagsResponse {
    nsfw: boolean;
    religious: boolean;
    political: boolean;
    racist: boolean;
    sexist: boolean;
    explicit: boolean;

    [key: string]: any;
}

export class JokeResponse implements IJokeResponse {
    id!: string;
    category!: JokeCategory;
    type!: JokeType;
    joke!: string | undefined;
    setup!: string | undefined;
    delivery!: string | undefined;
    flags!: JokeFlagsResponse;
    safe!: boolean;
    lang!: string;

    [key: string]: any;

    constructor(data?: IJokeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.category = _data["category"];
            this.type = _data["type"];
            this.joke = _data["joke"];
            this.setup = _data["setup"];
            this.delivery = _data["delivery"];
            this.flags = _data["flags"] ? JokeFlagsResponse.fromJS(_data["flags"]) : undefined as any;
            this.safe = _data["safe"];
            this.lang = _data["lang"];
        }
    }

    static fromJS(data: any): JokeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new JokeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["category"] = this.category;
        data["type"] = this.type;
        data["joke"] = this.joke;
        data["setup"] = this.setup;
        data["delivery"] = this.delivery;
        data["flags"] = this.flags ? this.flags.toJSON() : undefined as any;
        data["safe"] = this.safe;
        data["lang"] = this.lang;
        return data;
    }
}

export interface IJokeResponse {
    id: string;
    category: JokeCategory;
    type: JokeType;
    joke: string | undefined;
    setup: string | undefined;
    delivery: string | undefined;
    flags: JokeFlagsResponse;
    safe: boolean;
    lang: string;

    [key: string]: any;
}

/** Custom enum description */
export enum JokeType {
    Single = "Single",
    TwoPart = "TwoPart",
}

export class MediaResponse implements IMediaResponse {
    term!: string;
    category!: ImageCategory;
    imageId!: string | undefined;
    url!: string;
    data!: string | undefined;

    [key: string]: any;

    constructor(data?: IMediaResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.term = _data["term"];
            this.category = _data["category"];
            this.imageId = _data["imageId"];
            this.url = _data["url"];
            this.data = _data["data"];
        }
    }

    static fromJS(data: any): MediaResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MediaResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["term"] = this.term;
        data["category"] = this.category;
        data["imageId"] = this.imageId;
        data["url"] = this.url;
        data["data"] = this.data;
        return data;
    }
}

export interface IMediaResponse {
    term: string;
    category: ImageCategory;
    imageId: string | undefined;
    url: string;
    data: string | undefined;

    [key: string]: any;
}

export class ProblemDetails implements IProblemDetails {
    type!: string | undefined;
    title!: string | undefined;
    status!: number | undefined;
    detail!: string | undefined;
    instance!: string | undefined;

    [key: string]: any;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        return data;
    }
}

export interface IProblemDetails {
    type: string | undefined;
    title: string | undefined;
    status: number | undefined;
    detail: string | undefined;
    instance: string | undefined;

    [key: string]: any;
}

export class QuestionResponse implements IQuestionResponse {
    id!: string;
    text!: string;
    category!: string | undefined;
    rating!: ContentRating;

    [key: string]: any;

    constructor(data?: IQuestionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.text = _data["text"];
            this.category = _data["category"];
            this.rating = _data["rating"];
        }
    }

    static fromJS(data: any): QuestionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new QuestionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["text"] = this.text;
        data["category"] = this.category;
        data["rating"] = this.rating;
        return data;
    }
}

export interface IQuestionResponse {
    id: string;
    text: string;
    category: string | undefined;
    rating: ContentRating;

    [key: string]: any;
}

export class Anonymous implements IAnonymous {
    contentType!: string;
    contentDisposition!: string;
    headers!: { [key: string]: string[]; };
    length!: number;
    name!: string;
    fileName!: string;

    [key: string]: any;

    constructor(data?: IAnonymous) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.contentType = _data["ContentType"];
            this.contentDisposition = _data["ContentDisposition"];
            if (_data["Headers"]) {
                this.headers = {} as any;
                for (let key in _data["Headers"]) {
                    if (_data["Headers"].hasOwnProperty(key))
                        (this.headers as any)![key] = _data["Headers"][key] !== undefined ? _data["Headers"][key] : [];
                }
            }
            this.length = _data["Length"];
            this.name = _data["Name"];
            this.fileName = _data["FileName"];
        }
    }

    static fromJS(data: any): Anonymous {
        data = typeof data === 'object' ? data : {};
        let result = new Anonymous();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["ContentType"] = this.contentType;
        data["ContentDisposition"] = this.contentDisposition;
        if (this.headers) {
            data["Headers"] = {};
            for (let key in this.headers) {
                if (this.headers.hasOwnProperty(key))
                    (data["Headers"] as any)[key] = (this.headers as any)[key];
            }
        }
        data["Length"] = this.length;
        data["Name"] = this.name;
        data["FileName"] = this.fileName;
        return data;
    }
}

export interface IAnonymous {
    contentType: string;
    contentDisposition: string;
    headers: { [key: string]: string[]; };
    length: number;
    name: string;
    fileName: string;

    [key: string]: any;
}

export class Body extends Anonymous implements IBody {
    term!: string;
    prefix!: string;

    [key: string]: any;

    constructor(data?: IBody) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.term = _data["term"];
            this.prefix = _data["prefix"];
        }
    }

    static override fromJS(data: any): Body {
        data = typeof data === 'object' ? data : {};
        let result = new Body();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["term"] = this.term;
        data["prefix"] = this.prefix;
        super.toJSON(data);
        return data;
    }
}

export interface IBody extends IAnonymous {
    term: string;
    prefix: string;

    [key: string]: any;
}

export class Anonymous2 implements IAnonymous2 {
    contentType!: string;
    contentDisposition!: string;
    headers!: { [key: string]: string[]; };
    length!: number;
    name!: string;
    fileName!: string;

    [key: string]: any;

    constructor(data?: IAnonymous2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.contentType = _data["ContentType"];
            this.contentDisposition = _data["ContentDisposition"];
            if (_data["Headers"]) {
                this.headers = {} as any;
                for (let key in _data["Headers"]) {
                    if (_data["Headers"].hasOwnProperty(key))
                        (this.headers as any)![key] = _data["Headers"][key] !== undefined ? _data["Headers"][key] : [];
                }
            }
            this.length = _data["Length"];
            this.name = _data["Name"];
            this.fileName = _data["FileName"];
        }
    }

    static fromJS(data: any): Anonymous2 {
        data = typeof data === 'object' ? data : {};
        let result = new Anonymous2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["ContentType"] = this.contentType;
        data["ContentDisposition"] = this.contentDisposition;
        if (this.headers) {
            data["Headers"] = {};
            for (let key in this.headers) {
                if (this.headers.hasOwnProperty(key))
                    (data["Headers"] as any)[key] = (this.headers as any)[key];
            }
        }
        data["Length"] = this.length;
        data["Name"] = this.name;
        data["FileName"] = this.fileName;
        return data;
    }
}

export interface IAnonymous2 {
    contentType: string;
    contentDisposition: string;
    headers: { [key: string]: string[]; };
    length: number;
    name: string;
    fileName: string;

    [key: string]: any;
}

export class Body2 extends Anonymous2 implements IBody2 {
    term!: string;
    category!: ImageCategory;

    [key: string]: any;

    constructor(data?: IBody2) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.term = _data["term"];
            this.category = _data["category"];
        }
    }

    static override fromJS(data: any): Body2 {
        data = typeof data === 'object' ? data : {};
        let result = new Body2();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["term"] = this.term;
        data["category"] = this.category;
        super.toJSON(data);
        return data;
    }
}

export interface IBody2 extends IAnonymous2 {
    term: string;
    category: ImageCategory;

    [key: string]: any;
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}

/* eslint-disable */
// @ts-nocheck